/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamLegalEntityAssociationResource
 */
export interface TeamLegalEntityAssociationResource {
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamLegalEntityAssociationResource
     */
    legalEntityIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityAssociationResource
     */
    defaultLegalEntityId?: string;
}

/**
 * Check if a given object implements the TeamLegalEntityAssociationResource interface.
 */
export function instanceOfTeamLegalEntityAssociationResource(value: object): value is TeamLegalEntityAssociationResource {
    if (!('legalEntityIds' in value) || value['legalEntityIds'] === undefined) return false;
    return true;
}

export function TeamLegalEntityAssociationResourceFromJSON(json: any): TeamLegalEntityAssociationResource {
    return TeamLegalEntityAssociationResourceFromJSONTyped(json, false);
}

export function TeamLegalEntityAssociationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLegalEntityAssociationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityIds': json['legalEntityIds'],
        'defaultLegalEntityId': json['defaultLegalEntityId'] == null ? undefined : json['defaultLegalEntityId'],
    };
}

export function TeamLegalEntityAssociationResourceToJSON(value?: TeamLegalEntityAssociationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityIds': value['legalEntityIds'],
        'defaultLegalEntityId': value['defaultLegalEntityId'],
    };
}

